import Images from "~data/imageImports";
const ProcessData = [
      {
        id:"ps1",
        icon: "1",
        title: "Пройдите наши курсы",
        text:
        "Интенсивные, глубокие курсы как и для новичков, так и для профессионалов",
      },
      {
        id:"ps2",
        icon: "2",
        title: "Создайте портфолио",
        text:
        "Работайте в команде над реальнымы проектами",
      },
      {
        id:"ps3",
        icon: "3",
        title: "Начните работать",
        text:
          "После успешного обучения, поможем вам устроиться на работу",
      },
  ]
  export default ProcessData;